import React, { useState, useEffect } from "react";
import "./ToolTips.css";
import { toNormalText } from "../../../utils/helpers";
import { getToolTips } from "../api/meetings";

// Module-level flag to track if fetch has been called
let fetchCalled = false;

const ToolTips = ({ onClose }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tooltipData, setTooltipData] = useState({
    stateDetail: [],
    trendDefinitions: [],
    termDefinitions: []
  });

  useEffect(() => {
    const fetchTooltips = async () => {
      if (fetchCalled) {
        return;
      }
      fetchCalled = true;
      
      try {
        setLoading(true);
        const response = await getToolTips();
        if (response.success) {
          setTooltipData({
            stateDetail: response.tooltips.stateDetail || [],
            trendDefinitions: response.tooltips.trendDefinitions || [],
            termDefinitions: response.tooltips.termDefinitions || []
          });
        }
        setError(null);
      } catch (err) {
        console.error("Error fetching tooltips:", err);
        setError("Failed to load tooltips. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchTooltips();
  }, []);

  const handleClose = () => {
    fetchCalled = false;
    onClose();
  };

  if (loading) {
    return (
      <div className="tooltip-overlay">
        <div  className="tooltip-modal">
          <div className="tooltip-header">
            <h2>Understanding the Signals</h2>
            <button className="tooltip-close" onClick={handleClose}>×</button>
          </div>
          <div className="tooltip-loading">
            <div className="spinner"></div>
            <p>Loading tooltips...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tooltip-overlay">
        <div className="tooltip-modal">
          <div className="tooltip-header">
            <h2>Understanding the Signals</h2>
            <button className="tooltip-close" onClick={handleClose}>×</button>
          </div>
          <div className="tooltip-error">
            <p>{error}</p>
            <button onClick={handleClose}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tooltip-overlay">
      <div className="tooltip-modal">
        <div className="tooltip-header">
          <h2>Understanding the Signals</h2>
          <button className="tooltip-close" onClick={handleClose}>×</button>
        </div>

        {/* Shared States Section */}
        {tooltipData.stateDetail.length > 0 && (
          <div className="tooltip-section">
            <h3>Shared States</h3>
            <div className="tooltip-cards">
              {tooltipData.stateDetail.map((item, index) => (
                <div key={`state-${index}`} className="tooltip-card">
                  <span className="tooltip-badge">
                    {toNormalText(item.state)}
                  </span>
                  <p>{item.meaning}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Trends Section */}
        {tooltipData.trendDefinitions.length > 0 && (
          <div className="tooltip-section">
            <h3>Trends</h3>
            <div className="tooltip-cards">
              {tooltipData.trendDefinitions.map((item, index) => (
                <div key={`trend-${index}`} className="tooltip-card">
                  <span className="tooltip-badge">
                    {toNormalText(item.key)}
                  </span>
                  <p>{item.meaning}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Term Definitions Section */}
        {tooltipData.termDefinitions && tooltipData.termDefinitions.length > 0 && (
          <div className="tooltip-section">
            <h3>Biometric Terms</h3>
            <div className="tooltip-cards">
              {tooltipData.termDefinitions.map((item, index) => (
                <div key={`term-${index}`} className="tooltip-card term-card">
                  <span className="tooltip-badge term-badge">
                    {item.key === "hr_sync"? "HR Sync": item.key === "rr_sync"? "RR Sync":item.key === "hrv_sync"? "HRV Sync": toNormalText(item.key)}
                  </span>
                  <p>{item.meaning}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ToolTips;